import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import CourseDocumentPanelView from './CourseDocumentPanel.view';

const getTabItems = ({ downloadTabComponent, articleTabComponent }, t) => {
  return [
    { label: t('COURSE_DOCUMENT_PANEL.TAB.TAB_1.LABEL'), content: downloadTabComponent },
    { label: t('COURSE_DOCUMENT_PANEL.TAB.TAB_2.LABEL'), content: articleTabComponent },
  ];
};
const CourseDocumentPanel = ({ t, downloadTabComponent, articleTabComponent, ...restProps }) => {
  return (
    <CourseDocumentPanelView
      title={t('COURSE_DOCUMENT_PANEL.TITLE')}
      tabItems={getTabItems({ downloadTabComponent, articleTabComponent }, t)}
      {...restProps}
    />
  );
};

CourseDocumentPanel.propTypes = {
  downloadTabComponent: PropTypes.element,
  articleTabComponent: PropTypes.element,
};
CourseDocumentPanel.defaultProps = {
  downloadTabComponent: <Fragment />,
  articleTabComponent: <Fragment />,
};

export default withTranslation('classroom')(CourseDocumentPanel);
